<script>
  import AddDataDialog from "@/views/dataManage/section/AddDataDialog.vue";
  import ShowDataDialog from "@/views/dataManage/section/ShowDataDialog.vue";
  import SectionViewOpen from "./section/sectionViewOpen";
  export default {
    components: {SectionViewOpen, AddDataDialog, ShowDataDialog },
    data() {
      return {
        damnm: '',
        tableData: [],
        multipleSelection: [],
        wallType: '',
        total: 0,
        size: 10,
        current: 1,
        sortCol: '',
        order: '',
        section: {
          visible: false,
          formData: {
            secoordsList: [],
            sempList: [],
            backfillList: []
          }
        },
        showData: {
          visible: false,
          data: {}
        },
        typeList: []
      }
    },
    methods: {
      init() {
        this.request.get('/rm-sdictionary/v1/query/'+ '05').then(
            (res) => {
              if (res.ok) {
                this.typeList = res.data;
              } else {
                this.$message.error(res.error.message);
              }
            }
        );
      },
      page() {
        this.request.post('/rm-bsection/v1/page', {
          damnm: this.damnm,
          current: this.current,
          size: this.size,
          wallType: this.wallType,
          sortCol: this.sortCol,
          order: this.order
        }).then(
            (res) => {
              if (res.ok) {
                this.tableData = res.data.records;
                this.total = res.data.total;
              } else {
                this.$message.error(res.error.message);
              }
            }
        );
      },
      query() {
        this.current = 1;
        this.page();
      },
      clear() {
        this.damnm = '';
        this.size = 10;
        this.current = 1;
        this.sortCol = '';
        this.order = '';
        this.$refs.multipleTable.clearSort();
        this.$refs.multipleTable.clearSelection();
        this.page();
      },
      batchDel() {
        if (this.multipleSelection.length > 0) {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "error",
          }).then(
              () => {
                let ids = this.multipleSelection.map(_ => _.id);
                this.request.post('/rm-bsection/v1/ids', ids).then(
                    (res) => {
                      if (res.ok) {
                        this.$message.success("删除成功！");
                        this.query();
                      } else {
                        this.$message.error(res.error.message);
                      }
                    }
                );
              }
          );
        } else {
          this.$message.warning('请选择需要删除的数据');
        }
      },
      save() {
        this.section.operate = 'add';
        this.section.title = '新增断面';
        this.section.visible = true;
      },
      edit(val) {
        this.section.operate = 'edit';
        this.section.title = '修改断面';
        this.section.formData = JSON.parse(JSON.stringify(val));
        this.section.visible = true;
      },
      show(val) {
        this.showData.data = JSON.parse(JSON.stringify(val));
        this.showData.visible = true;
      },
      del(val) {
        this.request.delete(`/rm-bsection/v1/${val}`).then(
            (res) => {
              if (res.ok) {
                this.$message.success("删除成功！");
                this.query();
              } else {
                this.$message.error(res.error.message);
              }
            }
        );
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      onSectionViewOpen(row){
        this.$refs.sectionViewOpen.onSectionViewOpen(row.damcd);
      },
      handleSizeChange(val) {
        this.size = val;
        this.current = 1;
        this.page();
      },
      handleCurrentChange(val) {
        this.current = val;
        this.page();
      },
      tableRowClassName({row, rowIndex}) {
        return {
          backgroundColor: '#ffffff',
          fontSize: '1.2rem',
          fontWeight: 'normal',
          fontStretch: 'normal',
          fontFamily: 'PingFang SC',
          color: '#616f7b',
        };
      },
      sortChange({ prop, order }) {
        this.sortCol = prop;
        this.order = order;
        this.current = 1;
        this.page();
      },
      typeReset() {
        this.wallType = '';
        this.query();
      }
    },
    mounted() {
      this.page();
      this.init();
    },
    beforeDestroy() {
      this.$refs.sectionViewOpen.destroy();
    },
    watch:{
      "$store.state.head.skCd"() {
        //调用页面查询方法
        this.query();
      },
    }
  }
</script>

<template>
  <el-container>
    <section-view-open ref="sectionViewOpen"/>
    <el-header style="padding-top:20px ">
      <el-col>
        <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            class="queryButton"
            @click="save">
          新增
        </el-button>
        <el-input
            v-model="damnm"
            :maxlength="11"
            placeholder="断面编号\名称"
            style="width: 200px;height: 32px;margin: 0 10px;">
        </el-input>
        <el-button
            type="primary"
            size="small"
            style="background-color: #a8a8a8;border-color: #a8a8a8;"
            @click="clear">
          重置
        </el-button>
        <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="query">
          搜索
        </el-button>
      </el-col>
    </el-header>
    <el-main>
        <div  class="commonDiv">
          <el-table
              ref="multipleTable"
              :data="tableData"
              style="width: 100%;"
              height="calc(100% - 60px)"
              max-height="calc(100% - 60px)"
              border
              @sort-change="sortChange"
              :header-cell-style="{backgroundColor:'#f9f9ff',fontSize: '1.4rem',textAlign:'center',color:'#323232',
                              fontFamily:'PingFang SC',fontWeight:'normal',fontStretch:'normal',height:'5rem'}"
              :row-style="tableRowClassName"
              @selection-change="handleSelectionChange">
            <el-table-column
                prop="damnm"
                sortable="custom"
                align="center"
                label="断面名称">
              <template v-slot="scope">
                <a style="color: #46adf5;cursor: pointer;" @click="edit(scope.row)">{{ scope.row.damnm }}</a>
              </template>
            </el-table-column>
            <el-table-column
                prop="damcd"
                align="center"
                label="断面编号">
            </el-table-column>
            <el-table-column
                prop="type"
                align="center">
              <template #header>
                <span>坝类</span>
                <el-popover
                    placement="bottom"
                    trigger="click"
                    width="200">
                  <el-select v-model="wallType" style="margin-right: 10px;" placeholder="预警类别" @change="query">
                    <el-option
                        v-for="item in typeList"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                  </el-select>
                  <el-row style="margin-top: 2vh;">
                    <el-col :span="12">
                      <el-button class="dgSave" @click="typeReset">重 置</el-button>
                    </el-col>
                  </el-row>
                  <i slot="reference" class="el-icon-sxld"></i>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
                prop="no"
                sortable="custom"
                align="center"
                label="序号">
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
              <template slot-scope="scope">
                <el-tooltip content="查看断面" effect="light">
                  <img
                      @click="onSectionViewOpen(scope.row)"
                      src="~@/assets/images/operates/sectionView.png"
                      alt=""
                      style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                  />
                </el-tooltip>
                <el-tooltip content="删除" effect="light">
                  <el-popconfirm
                      title="确定删除吗？"
                      @confirm="del(scope.row.id)"
                  >
                    <img
                        src="~@/assets/images/operates/delete.png"
                        alt=""
                        slot="reference"
                        style="cursor: pointer;width: 3.5vh;height: 3.5vh;"
                    />
                  </el-popconfirm>
                </el-tooltip>

              </template>
            </el-table-column>
          </el-table>
            <div class="commonPage">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="current"
                        :page-size="size"
                        layout="total, prev, pager, next,sizes, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
    </el-main>
    <add-data-dialog :section.sync="section" @query="query"></add-data-dialog>
    <show-data-dialog :show-data="showData"></show-data-dialog>
  </el-container>
</template>

<style scoped>
::v-deep .el-input__inner {
  height: 32px;
}

.commonDiv {
  position: relative;
  background-color: #FFFFFF;
  height: calc(100vh - 208px);
}

.commonPage {
  position: absolute;
  right: 1.5rem;
  height: 60px;
}

/deep/ .el-pagination{
  white-space: nowrap;
  color: #303133;
  font-weight: 700;
  transform: translate(0, -50%);
  position: relative;
  top: 50%;
  right: 20px;
}
/deep/ .el-input__inner{
    height: 28px;
    line-height: 28px;
}

.el-icon-sxld {
  width: 10px;
  height: 9px;
  margin-left: 10px;
  cursor: pointer;
  background: url('../../assets/icons/sxld.png');
}

.dgSave {
  width: 8vh;
  height: 3vh;
  background-color: #53abfd;
  border-radius: 0vh;
  font-family: PingFang SC;
  font-size: 1.2vh;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3vh;
  letter-spacing: 0vh;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}
</style>
